import { createContext } from "react";
import { Breakpoint } from "@mui/material";
import { AuthTempInfo, AuthUser } from "@/types/Auth.ts";
import { AppMenuitem } from "@/types/Menu.ts";
import { AppModules } from "@/types/Module.ts";
import { ModuleUtils } from "@/utils/ModuleUtils.ts";
import { Company } from "@/types/Company.ts";
import { CompletedSupport } from "@/types/Support";
import { Channel } from "@/types/Channel.ts";

export type AppDevice = "mobile" | "tablet" | "pc";

export interface AppContextState {
  auth: { user: AuthUser | null; tempInfo?: AuthTempInfo };
  layout: {
    breakpoint: Breakpoint;
    device: "mobile" | "tablet" | "pc";
  };
  menu: {
    open: boolean;
    items: Array<AppMenuitem>;
  };
  company: Company | null;
  channels: Channel[];
  support: { completed: CompletedSupport[] };
  loaded: boolean;
  setAuthUser: (value: AuthUser) => void;
  setCompany: (value: Company) => void;
  setChannels: (value: Channel[]) => void;
  setCompletedSupport: (value: CompletedSupport[]) => void;
  setAuthTempInfo: (value: AuthTempInfo) => void;
  setLoaded: (value: boolean) => void;
  setMenuOpen: (value: boolean) => void;
  cleanState: () => void;
}

export const INITIAL_STATE: Omit<
  AppContextState,
  | "setAuthUser"
  | "setCompany"
  | "setChannels"
  | "setCompletedSupport"
  | "setAuthTempInfo"
  | "setLoaded"
  | "setMenuOpen"
  | "cleanState"
> = {
  auth: { user: null },
  layout: {
    breakpoint: "xs",
    device: "mobile",
  },
  menu: {
    open: false,
    items: [
      {
        id: AppModules.DASHBOARD,
        path: "/dashboard",
        label: ModuleUtils.getModuleName(AppModules.DASHBOARD),
        icon: "dashboard",
      },
      {
        id: AppModules.TICKETS,
        path: "/tickets",
        label: ModuleUtils.getModuleName(AppModules.TICKETS),
        icon: "confirmation_number",
      },
      /*{
        id: AppModules.CHANNELS,
        path: "/channels",
        label: ModuleUtils.getModuleName(AppModules.CHANNELS),
        icon: "campaign",
      },*/
      {
        id: AppModules.SUPPORTS,
        path: "/supports",
        label: ModuleUtils.getModuleName(AppModules.SUPPORTS),
        icon: "import_contacts",
        disabled: true,
      },
      // {
      //   id: AppModules.REPORTS,
      //   path: "/reports",
      //   label: ModuleUtils.getModuleName(AppModules.REPORTS),
      //   icon: "pie_chart",
      // },
      {
        id: AppModules.INVOICING,
        path: "/invoicing",
        label: ModuleUtils.getModuleName(AppModules.INVOICING),
        icon: "payments",
      },
      {
        id: AppModules.DYNAMIC_REPORT,
        path: "/dynamic-report",
        label: ModuleUtils.getModuleName(AppModules.DYNAMIC_REPORT),
        icon: "settings",
      },
      {
        id: AppModules.HELP,
        path: "/help",
        label: ModuleUtils.getModuleName(AppModules.HELP),
        icon: "help",
      },
    ],
  },
  company: null,
  channels: new Array<Channel>(),

  planInfo: null,
  support: {
    completed: new Array<CompletedSupport>(),
  },
  loaded: false,
} as unknown as AppContextState;

export const AppContext = createContext(INITIAL_STATE);
